import getWithToken from './base/get-with-token'

const getUsageAlertPointMap = (type, searchData) => getWithToken(`/dashboard/usage-alert-point-map?type=${type}`)({
    ...searchData,
})

export default getUsageAlertPointMap